import Vue from "vue";
import "@mdi/font/css/materialdesignicons.css";
import Vuetify from "vuetify/lib";
import VueScrollactive from "vue-scrollactive";

Vue.use(Vuetify);
Vue.use(VueScrollactive);

export default new Vuetify({
  breakpoint: {
    thresholds: {
      xs: 668,
      // 667px is the px width for iPhone 6/7/8 in landscape
      // this value also needs changed in styles/variables.scss
    },
  },
  /*
   * DEFAULTS
   * thresholds: Object
   * xs: 600
   * sm: 960
   * md: 1280
   * lg: 1920
   */
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        accent: "#007aff",
        primary: "#530D69",
        secondary: "#A558C9",
        background: "#F2E9F4",
        success: "#41b029",
      },
    },
  },
});
